import React from 'react'
import { Trans } from 'react-i18next'
import {
  InputOpened,
  Grid,
  Box,
  Typography,
  ButtonSecondary,
} from '@creditas-ui/react'
import { usePasswordIdentify } from './usePasswordIdentify'
import { Greetings } from './component/Greeting'
import TitleWithDocument from './component/TitleWithDocument'
import i18n from '~/i18n/i18n'
import { ContainerAction } from '~components/ContainerPages/ContainerPages'
import { FORMATTED_CPF_SIZE } from '~validators/cpf'

const PasswordIdentifyStep = () => {
  const {
    handlerInputChange,
    handleCreateAccountClick,
    handleSubmit,
    loading,
    document,
    errorMessage,
  } = usePasswordIdentify()

  return (
    <>
      <Grid
        height="100%"
        gridTemplateColumns={{
          _: 'repeat(4, 1fr)',
          '2xl': 'repeat(8, 1fr)',
          '5xl': 'repeat(12, 1fr)',
        }}
        gridTemplateRows="auto 1fr"
        data-testid="password-identify-step"
      >
        <Box gridColumn={{ _: '1/5', '2xl': '2/7', '5xl': '2/7' }}>
          <Greetings />
          <label htmlFor="document">
            <TitleWithDocument />
          </label>
        </Box>
        <Box
          gridColumn={{ _: '1/5', '2xl': '2/7', '5xl': '2/7' }}
          pt={{ _: '36px', '5xl': '56px' }}
        >
          <form onSubmit={handleSubmit}>
            <InputOpened
              id="document"
              placeholder={i18n.t('pages:password.identify.username.label')}
              onChange={handlerInputChange}
              disabled={loading}
              value={document}
              maxLength={FORMATTED_CPF_SIZE}
              error={
                <Trans
                  i18nKey={errorMessage}
                  components={[
                    <Typography
                      key="link-error-document"
                      color="error.60"
                      variant={{ _: 'bodySmRegular', '4xl': 'bodyMdRegular' }}
                    />,
                  ]}
                />
              }
            />
          </form>
        </Box>
      </Grid>
      <ContainerAction>
        <Grid
          height="100%"
          gridTemplateColumns={{
            _: 'repeat(4, 1fr)',
            '2xl': 'repeat(8, 1fr)',
            '5xl': 'repeat(12, 1fr)',
          }}
          alignItems="center"
        >
          <Box gridColumn={{ _: '1/5', '2xl': '2/7', '5xl': '2/7' }}>
            <Box mb={{ _: '32px' }}>
              <ButtonSecondary onClick={handleCreateAccountClick}>
                {i18n.t('pages:password.identify.button.create_account')}
              </ButtonSecondary>
            </Box>
          </Box>
        </Grid>
      </ContainerAction>
    </>
  )
}

export { PasswordIdentifyStep }
